<template>
    <!-- SOS -->
    <div class="family-number">
        <div class="Table-Bottom">
            <el-table
                :header-cell-style="{background:'#fff',color:'#000', height:'40px', }"
                ref="multipleTable"
                :data="tableData"
                :cell-style="{'text-align':'center'}"
                tooltip-effect="dark"
                @selection-change="handleSelectionChange">
                <el-table-column
                prop="address"
                label="操作"
                width="75"
                >
                <template #default="scope">
                    <span>{{ scope.$index +1 }}</span>
                </template>
                </el-table-column>
                <el-table-column
                prop="address"
                label="SOS"
                >
                <template #default="scope">
                    <el-input v-model="scope.row.phoneNo" ></el-input>
                    <!-- <el-input v-model="scope.row.name" ></el-input> -->

                </template>
                </el-table-column>
                <el-table-column
                prop="address"
                label="关系"
                >
                <template #default="scope">
                    <!-- <el-input v-model="scope.row.phoneNo" ></el-input> -->
                    <el-input v-model="scope.row.name" ></el-input>
                     
                </template>
                </el-table-column>
            </el-table>
        </div>
        <el-button type="primary" class="bottom-but" @click="baocunclick">保存设置</el-button>
    </div>
</template>

<script>
import { SosList ,sosUpdate} from '@/assets/api/zhongduan.js'

export default {
    components: {
        
    },
    data() {
        return {
            tableData: [
                {   
                    phoneNo: ''
                },
                {   
                    phoneNo: ''
                },
                {   
                    phoneNo: ''
                },
      
            ],
            bookList: []
        };
    },
    created() {
      console.log(this.$route.query.deviceId,this.$route.query.iemi,this.$route.query.name,'333333333333333333333');

        this.telephoneBookListClick()
    },
    mounted() {

    },
    methods: {
        telephoneBookListClick () {
            let params = {
                imei: this.$route.query.iemi,
            } 
            SosList(params).then((res)=> {
                console.log(res,'sos列表');
                if ( res.data.data.length ) {
                    if ( res.data.data.length < 3 ) {
                        res.data.data.forEach((item,index) => {
                            this.tableData[index].phoneNo = item.phoneNo
                        });
                    } else {
                        this.tableData = res.data.data
                    }
                    this.bookList = res.data.data
                }
            }).catch((err) => {
                console.log(err);
            })
        },
        baocunclick () {
            // let params = {}
            let booksList = []
            if ( this.bookList.length ) {
                for ( let item of this.tableData ) {
                    booksList.push({
                        id: item.id,
                        name: item.name,
                        mobile: item.phoneNo,
                        pic: item.pic
                    })
                }
                console.log('修改');
            } else {
                for ( let item of this.tableData ) {
                    booksList.push({
                        id: '',
                        name: '',
                        mobile: item.phoneNo,
                        pic: ''
                    })
                }
                console.log('新增');
            }
            sosUpdate(this.$route.query.iemi,booksList).then((res)=> {
                console.log(res,'新增');
                this.telephoneBookListClick()
                this.$message({
                    message: 'SOS设置成功！',
                    type: 'success'
                });
            }).catch((err) => {
                this.$message({
                            type: 'error',
                            message: err.response.data.msg
                        });
            })
            console.log(this.tableData,'提交');
        }
    },
};
</script>

<style scoped lang="scss">
.family-number {
    background-color: #fff;
    .Table-Bottom {
        width: 500px;
        border: 1px solid  #eee;
        margin-top: 20px;
        
        /deep/ {
            .el-input {
                width: 160px;
            }
            .el-table th.el-table__cell>.cell {
                text-align: center;
                font-size: 15px;
            }
        }
    }
    .bottom-but {
        margin: 20px 0px;
        margin-left: 240px;
    }
}
</style>
